import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeServiceTypeGroupCommand extends BaseCommand {
  CommandName = "ChangeServiceTypeGroup";
  Command: {
    Code: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, code: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Code: code };
  }
}
